import { CaretDownOutlined, DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { NavLink } from "react-router-dom";

const HelpAndTraining = () => {
  const items = [
    {
      label: <NavLink to="/gethelp">Get Help</NavLink>,
      key: "1",
    },
    {
      label: <NavLink to="/visitusercommunity">Visit User Community</NavLink>,
      key: "2",
    },
    {
      label: <NavLink to="/makeasuggestion">Make a Suggestion</NavLink>,
      key: "3",
    },
  ];
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <i
            className="nav-item-icon fa fa-question-circle fa-lg"
            style={{ fontSize: "20px" }}
          ></i>
          Help & Training
          <DownOutlined />

        </Space>
      </a>
    </Dropdown>
  );
};
export default HelpAndTraining;
